import React, { useState } from 'react';
import { ExternalTender, Tender } from '../types';
import { apiService } from '../services/apiService';
import { useModal } from './ModalProvider';
import ExternalTenderList from './ExternalTenderList';

interface OpportunitySearchProps {
  initialView?: 'ACTIVE' | 'FAVORITED' | 'ARCHIVED' | 'DISCARDED';
}

const OpportunitySearch: React.FC<OpportunitySearchProps> = ({ initialView = 'ACTIVE' }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [stateFilter, setStateFilter] = useState('ALL');
  const { showAlert } = useModal();

  const clearFilters = () => {
    setSearchTerm('');
    setStateFilter('ALL');
  };

  const addToWallet = async (external: ExternalTender): Promise<Tender | void> => {
    try {
      const result = await apiService.favoriteExternalTender(external.id);
      const created = result.tender;

      if (!result.alreadyFavorited) {
        const attachments = external.attachments || [];
        for (const attachment of attachments) {
          if (!attachment.url) continue;
          await apiService.createTenderAttachment(created.id, {
            name: attachment.name || 'Anexo',
            url: attachment.url,
            type: attachment.type,
            size: attachment.size,
          });
        }
      }

      await showAlert(
        result.alreadyFavorited
          ? 'Esta oportunidade já está em Licitações em Participação.'
          : 'Oportunidade adicionada a Licitações em Participação.',
        result.alreadyFavorited ? 'Já registrada' : 'Sucesso',
      );
      return created;
    } catch (error: any) {
      console.error('Erro ao adicionar oportunidade à participação:', error);
      await showAlert(error?.message || 'Erro ao adicionar oportunidade à participação.', 'Erro');
    }
  };

  return (
    <div className="px-4 sm:px-6 py-5 max-w-[1480px] mx-auto overflow-x-hidden">
      <ExternalTenderList
        externalSearchTerm={searchTerm}
        externalSetSearchTerm={setSearchTerm}
        externalStateFilter={stateFilter}
        externalSetStateFilter={setStateFilter}
        externalClearFilters={clearFilters}
        onAddToWallet={addToWallet}
        initialView={initialView}
      />
    </div>
  );
};

export default OpportunitySearch;
